import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import _ from "lodash";
import { defineComponent, reactive, inject } from "vue";
// components
// import GlobalFooter from "@/components/common/footer.vue";
// import { integrationList } from "@/config/homePage";
// context
import { jfsTime } from "@/config/homePage";
import { homePageContextKey } from "@/context/home-page";
import TeamInfoPopup from "@/components/common/team-info-popup";
export default defineComponent({
  name: "Integration",
  setup() {
    const {
      integrationState,
      integRef,
      homePageState
    } = inject(homePageContextKey);
    // 组件状态
    const state = reactive({
      // integrationList: integrationList,
      integrationData: {},
      showPopup: false
    });
    const onPopup = item => {
      state.showPopup = true;
      state.integrationData = item;
    };
    return () => {
      var _state$integrationDat;
      // 列表项
      const builtListItem = _.map(integrationState.integrationList, item => {
        return _createVNode("div", {
          "class": "list-item",
          "onClick": () => onPopup(item)
        }, [_createVNode("div", {
          "class": "rank"
        }, [item.match_ranking]), _createVNode("div", {
          "class": "name"
        }, [item.match_team_name]), _createVNode("div", {
          "class": "session"
        }, [_createVNode("span", {
          "style": "color: #cecc9c;"
        }, [item.match_victory_number]), _createVNode("span", {
          "style": "padding: 0 2px;"
        }, [_createTextVNode("/")]), _createVNode("span", {
          "style": "color: #77aac7;"
        }, [item.match_failure_number])]), _createVNode("div", {
          "class": "num"
        }, [item.match_total_score])]);
      });
      return _createVNode("div", {
        "class": "list-box"
      }, [_createVNode("div", {
        "class": "title-jx"
      }, [_createVNode("h2", null, [_createTextVNode("\u79EF\u5206\u8D5B")]), _createVNode("p", null, [jfsTime[homePageState.raceQuartertype]])]), _createVNode("div", {
        "class": "t-title"
      }, [_createVNode("div", {
        "class": "rank"
      }, [_createTextVNode("\u6392\u540D")]), _createVNode("div", {
        "class": "name"
      }, [_createTextVNode("\u6218\u961F\u540D\u79F0")]), _createVNode("div", {
        "class": "session"
      }, [_createTextVNode("\u80DC\u8D1F\u573A\u6B21")]), _createVNode("div", {
        "class": "num"
      }, [_createTextVNode("\u603B\u79EF\u5206")])]), _createVNode("div", {
        "ref": integRef,
        "class": "list-item-box",
        "id": "integRef"
      }, [builtListItem]), _createVNode(TeamInfoPopup, {
        "visible": state.showPopup,
        "teamInfo": {
          name: state.integrationData.match_team_name,
          members: (_state$integrationDat = state.integrationData.match_team) === null || _state$integrationDat === void 0 ? void 0 : _state$integrationDat.match_player_info
        },
        "onClose": () => state.showPopup = false
      }, null)]);
    };
  }
});